import { useTranslation } from "react-i18next";
import React from "react";
import { ProdAttrUtils } from "../../../utils/productAttributeUtils";
import { UiSectionH3 } from "../../../components/box/UiSectionH3";

const PickupAndReturn: React.FC<ProdDetailEleProps> = ({ d }) => {
  const { t } = useTranslation();

  if (d?.productType !== "TOUR") return null;
  return (
    <div className="mt-10 border-t border-[#EAEEF3] py-10">
      <UiSectionH3 title={t("Pickup & Return")} />
      <div className="mt-10 flex rounded-2xl border border-[#D7DCE3] py-6">
        <TtBox d={d} pickup={true} />
        <div className="h-auto w-[0.0625rem] bg-[#D7DCE3]" />
        <TtBox d={d} pickup={false} />
      </div>
    </div>
  );
};

export default PickupAndReturn;

const TtBox: React.FC<
  ProdDetailEleProps & {
    pickup: boolean;
  }
> = ({ d, pickup }) => {
  const { t } = useTranslation();
  const f = (name: ProdAttrNameTourInfo) =>
    ProdAttrUtils.TOUR.getDpValue(d?.attributeList ?? [], name);
  const location = JSON.parse(
    f(pickup ? "PICKUP_LOCATION" : "RETURN_LOCATION") || "{}",
  );
  let displayTime = f(pickup ? "PICKUP_TIME" : "RETURN_TIME");
  displayTime = displayTime.replace(/,/g, "; ");
  console.log(location.gps.join(
            ",",
          ));

  return (
    <div className="w-full px-6">
      <div className="mb-3 flex items-center gap-3">
        <img
          className="h-[1.25rem] w-[1.25rem]"
          src={
            pickup
              ? "../../assets/icons/location.svg"
              : "../../assets/icons/routing.svg"
          }
          alt="location"
        />

        <h3 className="text-[1.125rem] font-semibold leading-[1.625rem] text-[#232323]">
          {pickup ? t("Pickup") : t("Return")}
        </h3>
      </div>

      <p className="mb-2 text-base font-normal leading-[1.625rem] text-[#5E6D77]">
        <span className="font-semibold">{t("Time: ")}</span>{" "}
        {displayTime}
      </p>
      <p className="mb-2 text-base font-normal leading-[1.625rem] text-[#5E6D77]">
        <span className="font-semibold">{pickup ? t("Pickup address") : t("Return address")}: </span>{" "}
        {location.address}
      </p>
      {location.gps && (
        <a
          target="_blank"
          rel="noreferrer"
          href={`https://www.google.com/maps/search/?api=1&query=${location.gps.join(
            ",",
          )}`}
          className="text-base font-semibold leading-[1.625rem] text-[#232323] underline"
        >
          {t("View in maps")}
        </a>
      )}
    </div>
  );
};
